module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28806",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9585",
      "ably-hubspot-js": "static-2.4626",
      "atom": "static-1.4981",
      "conversations-async-data": "static-2.7577",
      "conversations-error-reporting": "static-1.8791",
      "conversations-internal-pub-sub": "static-1.15881",
      "conversations-internal-schema": "static-1.12691",
      "conversations-message-history": "static-1.12404",
      "conversations-test-sdk": "static-1.10412",
      "conversations-visitor-experience-components": "static-1.22169",
      "head-dlb": "static-1.4938",
      "hs-promise-utils": "static-1.5505",
      "hs-test-utils": "static-1.7923",
      "hubspot-dlb": "static-2.1832",
      "HubStyleTokens": "static-2.11369",
      "I18n": "static-7.1604",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2928",
      "jasmine-runner": "static-1.6378",
      "quartz": "static-1.6884",
      "react-dlb": "static-1.77",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.63",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4383",
      "StyleGuideUI": "static-3.485",
      "transmute": "static-2.85",
      "urlinator": "static-1.4442",
      "usage-tracker": "static-1.7246",
      "usage-tracker-core": "static-1.7096",
      "usage-tracker-public": "static-1.7057",
      "viral-links-lib": "static-1.6957",
      "visitor-ui-component-library": "static-1.6047",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4719",
      "conversations-prop-types": "static-1.7365",
      "conversations-visitor-message-history": "static-1.20906",
      "cssUtils": "static-1.771",
      "enviro": "static-4.428",
      "flux-actions": "static-1.325",
      "foundations-components": "static-1.7751",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6130",
      "hubspot-url-utils": "static-1.4049",
      "immutable": "static-2.77",
      "metrics-js": "static-1.9542",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.388",
      "raven": "static-3.5829",
      "react": "static-7.184",
      "react-aria": "static-1.64",
      "react-dom": "static-7.85",
      "react-redux": "static-7.70",
      "react-rhumb": "static-1.16568",
      "react-utils": "static-2.5275",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8055",
      "signup-constants": "static-1.18687",
      "styled-components": "static-2.88",
      "usage-tracker-multi": "static-1.5660",
      "visitor-ui-component-library-icons": "static-1.5858",
      "hs-promise-rejection-tracking": "static-1.5489",
      "raven-hubspot": "static-1.6136",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3334",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.84",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.80",
      "quartz-config": "static-1.662",
      "quartz-core": "static-1.6103",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4761",
      "foundations-theming": "static-1.4324",
      "UIComponents": "static-3.8316",
      "customer-data-email": "static-1.17877",
      "cv-backend-services": "static-1.1542",
      "immutable-less": "static-1.4563",
      "conversations-skeleton-state": "static-1.7161",
      "crm-events-viz-core": "static-1.32878",
      "customer-data-objects": "static-1.7570",
      "icons": "static-2.639",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4556",
      "ui-images": "static-2.1131",
      "HeadJS": "static-2.736",
      "framer-motion": "static-1.70",
      "hs-test-utils-bend-plugin": "static-1.3034",
      "msw": "static-1.39",
      "testing-library": "static-1.150",
      "i18n-data": "static-1.219",
      "moment-timezone": "static-5.81",
      "jasmine": "static-4.4234",
      "signup-ui-url-generator": "static-2.7943",
      "HubStyle": "static-2.11677",
      "quartz-i18n": "static-1.559",
      "sassPrefix": "static-1.154",
      "bend-plugin-foundations-components": "static-1.4020",
      "floating-ui": "static-1.54",
      "foundations-theming-specialty": "static-1.2040",
      "hs-story-utils": "static-1.9340",
      "react-virtualized": "static-2.97",
      "tanstack-table": "static-1.53",
      "trellis-assets": "static-1.1563",
      "ui-fonts": "static-1.631",
      "hs-locale-management": "static-1.17",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3844",
      "history": "static-4.47",
      "quartz-routing": "static-1.314",
      "usage-tracker-anonymous": "static-1.5663",
      "bender-build-tools": "static-1.3063",
      "dispatcher": "static-1.134",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.820",
      "hubspotter-http": "static-1.4580",
      "mobile-manifest-mixins": "static-1.509",
      "module-federation": "static-1.21",
      "quartz-auth": "static-1.559",
      "quartz-head": "static-1.549",
      "quartz-test": "static-1.559",
      "quartz-tracking": "static-1.263",
      "usage-tracker-container": "static-1.7236",
      "bend-plugin-foundations-theming": "static-1.2807",
      "foundations-theming-base": "static-1.3309",
      "stylex": "static-1.30",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4561",
      "customer-data-ui-utilities": "static-1.9736",
      "FileManagerCore": "static-1.38833",
      "FileManagerLib": "static-1.38974",
      "hubspot-apollo-client": "static-1.4788",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.523",
      "timezone-utils": "static-2.5154",
      "ui-gdpr-components": "static-1.10258",
      "ts-schema": "static-1.4006",
      "ai-components-ui-library": "static-1.8710",
      "avatar-components": "static-1.2404",
      "content-assistance-lib": "static-1.7620",
      "crm-component-utils": "static-1.38821",
      "crm-display-components": "static-1.24571",
      "crm-fe-perf": "static-1.22816",
      "crm-links": "static-1.6188",
      "crm-message-bus": "static-1.42727",
      "crm-search-service-types": "static-1.1062",
      "crm-source-interpretation-lib": "static-1.5246",
      "customer-data-communicator": "static-1.45238",
      "customer-data-filters-ui": "static-1.39405",
      "customer-data-objects-ui-components": "static-1.12931",
      "customer-data-properties": "static-1.51226",
      "customer-data-rte": "static-1.32758",
      "draft-plugins": "static-2.21516",
      "file-manager-components": "static-1.23334",
      "framework-data-schema-resolvers": "static-1.6785",
      "frontend-preferences-client": "static-1.7834",
      "hubspot-prosemirror": "static-1.17974",
      "object-comments-thread-lib": "static-1.10413",
      "prosemirror-user-and-team-at-mentions": "static-1.398",
      "reference-resolvers-lite": "static-1.8001",
      "ui-addon-upgrades": "static-9.17857",
      "universal-associations-select": "static-1.10923",
      "universal-record-utils-lib": "static-1.601",
      "inbound-db-properties-service-client": "static-1.3773",
      "property-translator": "static-1.5317",
      "chirp-fetch": "static-1.1792",
      "react-router-dom": "static-5.26",
      "hub-http-shared-msw-handlers": "static-1.9756",
      "hubspotter-http-shared-msw-handlers": "static-1.9754",
      "usage-tracker-session-replay": "static-1.4932",
      "react-dnd-compat": "static-1.4529",
      "audio-components": "static-1.5782",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29129",
      "FileManagerImages": "static-1.36485",
      "foundations-components-legacy": "static-1.776",
      "immerable": "static-1.4063",
      "ui-universal-auth": "static-1.8859",
      "video-components": "static-1.12982",
      "video-data-lib": "static-1.34637",
      "video-embed": "static-1.35471",
      "hubspot-apollo-cache": "static-1.247",
      "chatspot-core": "static-1.20867",
      "ContentUtils": "static-1.68077",
      "copilot-toolkit": "static-1.10875",
      "superstore": "static-1.4679",
      "ui-addon-video-player": "static-1.8607",
      "ui-coaching-tips": "static-1.28284",
      "card-properties-lib": "static-1.43892",
      "commerce-subscription-lib": "static-1.36832",
      "crm-actions": "static-1.6228",
      "crm-cards-sdk": "static-1.43305",
      "customer-data-properties-shared-msw-handlers": "static-1.9083",
      "customer-data-property-utils": "static-1.7995",
      "customer-data-tracking": "static-1.6795",
      "hs-resources": "static-1.51",
      "inbound-db-meta-service-client": "static-1.3518",
      "pulse": "static-1.456",
      "framework-data-table": "static-2.11704",
      "location-customization-utils-lib": "static-1.8954",
      "calling-error-reporting": "static-1.31218",
      "calling-internal-common": "static-1.31212",
      "calling-usage-tracker": "static-1.6451",
      "crm_data": "static-4.91660",
      "customer-data-content": "static-1.27109",
      "draft-content-plugins": "static-1.28026",
      "draft-convert": "static-2.71",
      "draft-extend": "static-3.73",
      "draft-js": "static-5.76",
      "draft-signature-plugin": "static-1.23827",
      "EmailSignatureEditor": "static-1.24176",
      "hubspot-prosemirror-plugins": "static-1.17966",
      "integration-settings-components": "static-1.15190",
      "integrations-lib": "static-1.15819",
      "integrations-tracking-lib": "static-1.5507",
      "native-integrations-shared-strings": "static-1.7696",
      "nav-meta": "static-1.29334",
      "onboarding-scopes": "static-1.6375",
      "outreach-assistant-email-generation": "static-1.6036",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37726",
      "react-colorpicker": "static-2.10120",
      "reference-resolvers": "static-1.8078",
      "rich-text-lib": "static-1.19675",
      "sales-email-signature-service-client": "static-1.3753",
      "sequences-lib": "static-1.7886",
      "ui-addon-i18n": "static-1.11059",
      "ui-addon-iframeable": "static-1.8961",
      "ui-business-units-lib": "static-1.8951",
      "ui-shepherd-react": "static-3.10058",
      "user-context": "static-1.5011",
      "whatsapp-sending-lib": "static-1.5361",
      "customer-data-filters-ui-msw-helpers": "static-1.21840",
      "customer-data-reference-ui-components": "static-1.13066",
      "FormUrlGenerator": "static-2.4629",
      "framework-builder-read-service-client": "static-1.3937",
      "framework-data-schema-quick-fetch": "static-1.6690",
      "multi-account-reference-resolvers": "static-1.886",
      "onboarding-tours": "static-1.16438",
      "reporting-datasets-permissions-lib": "static-1.13410",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21427",
      "calling-global-api": "static-1.64141",
      "calling-lifecycle-internal": "static-1.65523",
      "calling-lifecycle-messages": "static-1.57817",
      "commerce-products-lib": "static-1.9196",
      "conditional-properties-service-client": "static-1.3725",
      "external-options-client-types": "static-1.4086",
      "google-libphonenumber": "static-1.36",
      "inbounddb-objects-service-types": "static-1.4151",
      "meetings-icalendar-utils-lib": "static-1.540",
      "multi-currency-client-types": "static-1.3619",
      "object-builder-ui-client": "static-1.48427",
      "pipeline-validation-client-types": "static-1.3894",
      "property-value-citations": "static-1.1840",
      "smart-property-lib": "static-1.6485",
      "tiered-pricing": "static-1.1031",
      "ui-addon-form-validation": "static-1.10901",
      "video-components-external": "static-1.10979",
      "batch-promise": "static-1.1463",
      "crm-pipelines-api-client-types": "static-1.4070",
      "persist-promise": "static-1.3620",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25089",
      "knowledge-content-types": "static-1.8456",
      "payment-link-components": "static-1.23272",
      "ui-addon-emoji-picker": "static-1.9797",
      "call-summary": "static-1.38831",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9902",
      "laboratory-lib": "static-3.7069",
      "merchandise-lib": "static-1.262",
      "purchase-motions-components": "static-1.5709",
      "crm-object-search-query-utilities": "static-1.9370",
      "amplitude-session-replay-browser": "static-1.58",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.654",
      "content-icons-ui": "static-1.2204",
      "social-insights-client-types": "static-1.21825",
      "outpost": "static-1.4103",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4720",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5505",
      "magpie-types": "static-1.4965",
      "simple-logging-lib": "static-1.2962",
      "growth-onboarding-feedback-components": "static-1.6492",
      "customer-data-sidebar": "static-2.45750",
      "enrichment-properties-lib": "static-1.15603",
      "commerce-billing-lib": "static-1.18811",
      "commerce-shared-components-lib": "static-1.18279",
      "commerce-tools-ui-lib": "static-1.10134",
      "directed-graph": "static-1.848",
      "event-emitter": "static-1.858",
      "fast-json-patch": "static-1.61",
      "customer-data-associations": "static-1.7237",
      "deal-intel-decorators": "static-1.1675",
      "reporting-data": "static-1.67094",
      "tanstack-virtual": "static-1.28",
      "ui-addon-draggable": "static-3.4679",
      "crm-record-cards-service-types": "static-1.3538",
      "self-service-api": "static-1.10155",
      "crm_universal": "static-1.21849",
      "SalesContentIndexUI": "static-3.9104",
      "content-embed-lib": "static-1.7251",
      "data-model-builder-lib": "static-1.12047",
      "remote-ui": "static-1.63",
      "ui-components-test-utils": "static-1.5507",
      "ui-extensions-remote-renderer": "static-1.16737",
      "universal-page-editor-lib": "static-1.2919",
      "integrations-error-boundary-lib": "static-1.13234",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10284",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.373",
      "messaging-types-lib": "static-1.45711",
      "data-token-picker": "static-1.16246",
      "sequences-client-types-lib": "static-1.7743",
      "foundations-components-test-utils": "static-1.5234",
      "navigation-messaging": "static-1.7024",
      "getting-started-shared-tasks": "static-1.18237",
      "getting-started-shared-tasks-store": "static-1.17355",
      "onboarding-tours-utils": "static-1.504",
      "messaging-usage-based-billing-components-lib": "static-1.836",
      "whatsapp-management-lib": "static-1.8520",
      "growth-data-modal": "static-1.5291",
      "growth-onboarding-confetti": "static-1.2981",
      "growth-onboarding-next-action-utils": "static-1.1644",
      "navigation-components": "static-1.17697",
      "onboarding-tours-client": "static-1.4652",
      "ui-shepherd-tracker": "static-1.7439",
      "shared-worker-versioning": "static-1.10948",
      "voice-sms-access-library": "static-1.633",
      "commerce-permissions": "static-1.676",
      "products-iframe-lib": "static-1.7670",
      "products-ui-components-shared-msw-handlers": "static-1.10138",
      "data-agent-kit": "static-1.54",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9839",
      "fsm": "static-1.3645",
      "policy-lib": "static-1.6694",
      "react-tinymce": "static-1.54979",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54105",
      "tinymce-plugins": "static-1.57219",
      "tinymce-themes": "static-1.56075",
      "content-media-composition-data-lib": "static-1.11963",
      "content-media-compositions": "static-2.15970",
      "idb-keyval": "static-1.42",
      "media-bridge-lib": "static-1.18767",
      "ui-addon-opt": "static-4.8292",
      "commerce-tours-lib": "static-1.5931",
      "growth-onboarding-reliability": "static-1.4995",
      "sales-checkout-service-client": "static-1.3569",
      "ai-addon-copilot-preview": "static-1.7922",
      "calling-cross-tab-library": "static-1.19185",
      "calling-lifecycle-usage-tracker": "static-1.8460",
      "wootric-nps": "static-1.6894",
      "nav-client-types": "static-1.2268",
      "purchase-motions-api": "static-1.5712",
      "reactive-lib": "static-1.634",
      "card-payment-highlight-lib": "static-1.36887",
      "card-subscription-highlight-lib": "static-1.39255",
      "commerce-contract-lib": "static-1.11640",
      "invoices-highlight-card-lib": "static-1.54402",
      "orders-highlight-card-lib": "static-1.21206",
      "products-highlight-card-lib": "static-1.17480",
      "quotes-highlight-card-lib": "static-1.71636",
      "usage-based-billing-components-lib": "static-1.8362",
      "utility-belt": "static-1.2450",
      "payments-enrollment-embed-lib": "static-1.22361",
      "stripe-embedded-components": "static-1.7345",
      "growth-onboarding-empty-states": "static-1.5554",
      "InboxConnectUtils": "static-4.14555",
      "payments-post-enroll-local-storage-lib": "static-1.5022",
      "qrcode-generator": "static-1.67",
      "trials-service-types": "static-1.3812",
      "deal-intel-utils": "static-1.1679",
      "storybook-react": "static-1.31",
      "reporting-client-types": "static-1.2430",
      "react-flip-move": "static-1.68",
      "FireAlarmUi": "static-1.4440",
      "sales-templates-service-types-lib": "static-1.4096",
      "ui-asset-management-lib": "static-1.10899",
      "association-settings-lib": "static-1.10026",
      "collaboration-sidebar": "static-1.57509",
      "conditional-property-settings-modal": "static-1.12253",
      "data-model-commons-lib": "static-1.12302",
      "final-form": "static-1.68",
      "html-to-image": "static-1.52",
      "nudge-client-utils": "static-1.2383",
      "object-definition-builder-lib": "static-1.6994",
      "property-management-iframe": "static-1.12843",
      "property-usages-lib": "static-1.5322",
      "reactflow": "static-1.62",
      "simple-data-table": "static-1.2518",
      "used-in-list-lib": "static-1.6849",
      "visual-association": "static-1.5777",
      "highcharts": "static-8.102",
      "reporting-visualizations": "static-1.59170",
      "ui-extensibility-client-types": "static-1.3849",
      "microsoft-drive-integration-lib": "static-1.51",
      "automation-platform-service-types": "static-1.2555",
      "ContentData": "static-1.68152",
      "email-portal-health-service-types": "static-1.887",
      "marketing-email-service-types": "static-1.1847",
      "messaging-shared-utils-lib": "static-1.285",
      "messaging-user-info-utils-lib": "static-1.455",
      "content-whatsapp-service-types": "static-1.315",
      "marketing-platform-lib": "static-1.6761",
      "short-messages-app-service-client": "static-1.3892",
      "ui-tool-access": "static-1.10057",
      "onboarding-data-sync-lib": "static-1.1810",
      "growth-onboarding-next-action-components": "static-1.1672",
      "user-context-client": "static-1.4522",
      "nest": "static-1.134",
      "calling-orchestration-schema": "static-1.35410",
      "sales-views-client-types": "static-1.4173",
      "trellis-story-utils": "static-1.4428",
      "hub-http-contrib": "static-1.2953",
      "interframe": "static-3.4673",
      "tinymce-data": "static-1.40190",
      "ui-addon-sales-email": "static-1.5122",
      "codemirror": "static-5.93",
      "layout-dnd-components": "static-1.12270",
      "layout-dnd-utils": "static-1.11245",
      "react-codemirror": "static-1.10534",
      "ui-brand-identity-lib": "static-1.14839",
      "NamespacedHubStyle": "static-2.8995",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9757",
      "ai-settings-ui-library": "static-1.7740",
      "copilot-plugins": "static-1.10848",
      "products-ui-components": "static-1.39715",
      "quotes-ui-lib": "static-1.80357",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6917",
      "invoices-ui-lib": "static-1.54418",
      "commerce-products-api": "static-1.2158",
      "invoices-iframe-lib": "static-1.56476",
      "quotes-modal-lib": "static-1.102314",
      "platform-infra-nav-components": "static-1.7594",
      "reporting-ui-components": "static-2.64365",
      "subscription-experience-data-types": "static-1.14768",
      "marketplace-ui-apps-core": "static-1.17871",
      "stripe-connect-js": "static-1.66",
      "ui-addon-react-router-dom": "static-1.9456",
      "nested-table": "static-1.135",
      "association-translator": "static-1.3093",
      "crm-settings-header-lib": "static-1.8249",
      "settings-ui-nav": "static-2.10101",
      "chatspot-widget-iframe": "static-1.20858",
      "collaboration-sidebar-common": "static-1.2306",
      "crm-properties-common-lib": "static-1.5787",
      "ui-addon-draggable-compat": "static-2.4165",
      "nudge-custom-function-registry": "static-1.2140",
      "nudge-renderer-utils": "static-1.2459",
      "whisper-core-api": "static-1.6334",
      "property-management-common": "static-1.5131",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14992",
      "advanced-menus-lib": "static-1.11949",
      "ExportDialog": "static-6.10300",
      "ui-memberships-settings-lib": "static-1.33789",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9570",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.14006",
      "highlight.js": "static-1.77",
      "reporting-action-components": "static-1.41016",
      "reporting-snowflake": "static-1.55712",
      "commerce-tax-lib": "static-1.430",
      "property-description-translator": "static-1.3762",
      "commerce-analytics-service-client": "static-1.3557",
      "totals-ui-components": "static-1.23330",
      "reporting-plugins": "static-1.10152",
      "reporting-reports": "static-1.66772",
      "edison-service-client-types": "static-1.297",
      "developer-experience-shared-components": "static-1.10419",
      "marketplace-ui-client-types": "static-1.16745",
      "marketplace-ui-common": "static-1.19338",
      "ui-addon-integrations-directory-panel": "static-2.7905",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.83",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14991",
      "simple-menus-lib": "static-1.16508",
      "academy-common-lib": "static-1.13466",
      "dashboard-lib": "static-1.81151",
      "share-with-third-party-component-lib": "static-1.8606",
      "commerce-totals-service-types": "static-1.3746",
      "campaign-roi-lib": "static-1.8688",
      "apps-service-types": "static-1.3788",
      "oauth-service-types": "static-1.4160",
      "academy-service-client": "static-1.3591",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28806",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9585",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4626",
      "atom": "/atom/static-1.4981",
      "conversations-async-data": "/conversations-async-data/static-2.7577",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8791",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15881",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12691",
      "conversations-message-history": "/conversations-message-history/static-1.12404",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10412",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22169",
      "head-dlb": "/head-dlb/static-1.4938",
      "hs-promise-utils": "/hs-promise-utils/static-1.5505",
      "hs-test-utils": "/hs-test-utils/static-1.7923",
      "hubspot-dlb": "/hubspot-dlb/static-2.1832",
      "HubStyleTokens": "/HubStyleTokens/static-2.11369",
      "I18n": "/I18n/static-7.1604",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2928",
      "jasmine-runner": "/jasmine-runner/static-1.6378",
      "quartz": "/quartz/static-1.6884",
      "react-dlb": "/react-dlb/static-1.77",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.63",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4383",
      "StyleGuideUI": "/StyleGuideUI/static-3.485",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4442",
      "usage-tracker": "/usage-tracker/static-1.7246",
      "usage-tracker-core": "/usage-tracker-core/static-1.7096",
      "usage-tracker-public": "/usage-tracker-public/static-1.7057",
      "viral-links-lib": "/viral-links-lib/static-1.6957",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6047",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4719",
      "conversations-prop-types": "/conversations-prop-types/static-1.7365",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20906",
      "cssUtils": "/cssUtils/static-1.771",
      "enviro": "/enviro/static-4.428",
      "flux-actions": "/flux-actions/static-1.325",
      "foundations-components": "/foundations-components/static-1.7751",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6130",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
      "immutable": "/immutable/static-2.77",
      "metrics-js": "/metrics-js/static-1.9542",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.388",
      "raven": "/raven/static-3.5829",
      "react": "/react/static-7.184",
      "react-aria": "/react-aria/static-1.64",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.70",
      "react-rhumb": "/react-rhumb/static-1.16568",
      "react-utils": "/react-utils/static-2.5275",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8055",
      "signup-constants": "/signup-constants/static-1.18687",
      "styled-components": "/styled-components/static-2.88",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5660",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5858",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
      "raven-hubspot": "/raven-hubspot/static-1.6136",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.80",
      "quartz-config": "/quartz-config/static-1.662",
      "quartz-core": "/quartz-core/static-1.6103",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4761",
      "foundations-theming": "/foundations-theming/static-1.4324",
      "UIComponents": "/UIComponents/static-3.8316",
      "customer-data-email": "/customer-data-email/static-1.17877",
      "cv-backend-services": "/cv-backend-services/static-1.1542",
      "immutable-less": "/immutable-less/static-1.4563",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7161",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32878",
      "customer-data-objects": "/customer-data-objects/static-1.7570",
      "icons": "/icons/static-2.639",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4556",
      "ui-images": "/ui-images/static-2.1131",
      "HeadJS": "/HeadJS/static-2.736",
      "framer-motion": "/framer-motion/static-1.70",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3034",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.150",
      "i18n-data": "/i18n-data/static-1.219",
      "moment-timezone": "/moment-timezone/static-5.81",
      "jasmine": "/jasmine/static-4.4234",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
      "HubStyle": "/HubStyle/static-2.11677",
      "quartz-i18n": "/quartz-i18n/static-1.559",
      "sassPrefix": "/sassPrefix/static-1.154",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4020",
      "floating-ui": "/floating-ui/static-1.54",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2040",
      "hs-story-utils": "/hs-story-utils/static-1.9340",
      "react-virtualized": "/react-virtualized/static-2.97",
      "tanstack-table": "/tanstack-table/static-1.53",
      "trellis-assets": "/trellis-assets/static-1.1563",
      "ui-fonts": "/ui-fonts/static-1.631",
      "hs-locale-management": "/hs-locale-management/static-1.17",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3844",
      "history": "/history/static-4.47",
      "quartz-routing": "/quartz-routing/static-1.314",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5663",
      "bender-build-tools": "/bender-build-tools/static-1.3063",
      "dispatcher": "/dispatcher/static-1.134",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.820",
      "hubspotter-http": "/hubspotter-http/static-1.4580",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
      "module-federation": "/module-federation/static-1.21",
      "quartz-auth": "/quartz-auth/static-1.559",
      "quartz-head": "/quartz-head/static-1.549",
      "quartz-test": "/quartz-test/static-1.559",
      "quartz-tracking": "/quartz-tracking/static-1.263",
      "usage-tracker-container": "/usage-tracker-container/static-1.7236",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2807",
      "foundations-theming-base": "/foundations-theming-base/static-1.3309",
      "stylex": "/stylex/static-1.30",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4561",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9736",
      "FileManagerCore": "/FileManagerCore/static-1.38833",
      "FileManagerLib": "/FileManagerLib/static-1.38974",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4788",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.523",
      "timezone-utils": "/timezone-utils/static-2.5154",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10258",
      "ts-schema": "/ts-schema/static-1.4006",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8710",
      "avatar-components": "/avatar-components/static-1.2404",
      "content-assistance-lib": "/content-assistance-lib/static-1.7620",
      "crm-component-utils": "/crm-component-utils/static-1.38821",
      "crm-display-components": "/crm-display-components/static-1.24571",
      "crm-fe-perf": "/crm-fe-perf/static-1.22816",
      "crm-links": "/crm-links/static-1.6188",
      "crm-message-bus": "/crm-message-bus/static-1.42727",
      "crm-search-service-types": "/crm-search-service-types/static-1.1062",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5246",
      "customer-data-communicator": "/customer-data-communicator/static-1.45238",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39405",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12931",
      "customer-data-properties": "/customer-data-properties/static-1.51226",
      "customer-data-rte": "/customer-data-rte/static-1.32758",
      "draft-plugins": "/draft-plugins/static-2.21516",
      "file-manager-components": "/file-manager-components/static-1.23334",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6785",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7834",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17974",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10413",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.398",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8001",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17857",
      "universal-associations-select": "/universal-associations-select/static-1.10923",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.601",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3773",
      "property-translator": "/property-translator/static-1.5317",
      "chirp-fetch": "/chirp-fetch/static-1.1792",
      "react-router-dom": "/react-router-dom/static-5.26",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9756",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9754",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4932",
      "react-dnd-compat": "/react-dnd-compat/static-1.4529",
      "audio-components": "/audio-components/static-1.5782",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29129",
      "FileManagerImages": "/FileManagerImages/static-1.36485",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.776",
      "immerable": "/immerable/static-1.4063",
      "ui-universal-auth": "/ui-universal-auth/static-1.8859",
      "video-components": "/video-components/static-1.12982",
      "video-data-lib": "/video-data-lib/static-1.34637",
      "video-embed": "/video-embed/static-1.35471",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.247",
      "chatspot-core": "/chatspot-core/static-1.20867",
      "ContentUtils": "/ContentUtils/static-1.68077",
      "copilot-toolkit": "/copilot-toolkit/static-1.10875",
      "superstore": "/superstore/static-1.4679",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8607",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28284",
      "card-properties-lib": "/card-properties-lib/static-1.43892",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36832",
      "crm-actions": "/crm-actions/static-1.6228",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43305",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9083",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7995",
      "customer-data-tracking": "/customer-data-tracking/static-1.6795",
      "hs-resources": "/hs-resources/static-1.51",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3518",
      "pulse": "/pulse/static-1.456",
      "framework-data-table": "/framework-data-table/static-2.11704",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8954",
      "calling-error-reporting": "/calling-error-reporting/static-1.31218",
      "calling-internal-common": "/calling-internal-common/static-1.31212",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6451",
      "crm_data": "/crm_data/static-4.91660",
      "customer-data-content": "/customer-data-content/static-1.27109",
      "draft-content-plugins": "/draft-content-plugins/static-1.28026",
      "draft-convert": "/draft-convert/static-2.71",
      "draft-extend": "/draft-extend/static-3.73",
      "draft-js": "/draft-js/static-5.76",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23827",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24176",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17966",
      "integration-settings-components": "/integration-settings-components/static-1.15190",
      "integrations-lib": "/integrations-lib/static-1.15819",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5507",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7696",
      "nav-meta": "/nav-meta/static-1.29334",
      "onboarding-scopes": "/onboarding-scopes/static-1.6375",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6036",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37726",
      "react-colorpicker": "/react-colorpicker/static-2.10120",
      "reference-resolvers": "/reference-resolvers/static-1.8078",
      "rich-text-lib": "/rich-text-lib/static-1.19675",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3753",
      "sequences-lib": "/sequences-lib/static-1.7886",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11059",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8961",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8951",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10058",
      "user-context": "/user-context/static-1.5011",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5361",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21840",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13066",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4629",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3937",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6690",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.886",
      "onboarding-tours": "/onboarding-tours/static-1.16438",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13410",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21427",
      "calling-global-api": "/calling-global-api/static-1.64141",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65523",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57817",
      "commerce-products-lib": "/commerce-products-lib/static-1.9196",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3725",
      "external-options-client-types": "/external-options-client-types/static-1.4086",
      "google-libphonenumber": "/google-libphonenumber/static-1.36",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4151",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.540",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3619",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48427",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3894",
      "property-value-citations": "/property-value-citations/static-1.1840",
      "smart-property-lib": "/smart-property-lib/static-1.6485",
      "tiered-pricing": "/tiered-pricing/static-1.1031",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10901",
      "video-components-external": "/video-components-external/static-1.10979",
      "batch-promise": "/batch-promise/static-1.1463",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4070",
      "persist-promise": "/persist-promise/static-1.3620",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25089",
      "knowledge-content-types": "/knowledge-content-types/static-1.8456",
      "payment-link-components": "/payment-link-components/static-1.23272",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9797",
      "call-summary": "/call-summary/static-1.38831",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9902",
      "laboratory-lib": "/laboratory-lib/static-3.7069",
      "merchandise-lib": "/merchandise-lib/static-1.262",
      "purchase-motions-components": "/purchase-motions-components/static-1.5709",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9370",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.654",
      "content-icons-ui": "/content-icons-ui/static-1.2204",
      "social-insights-client-types": "/social-insights-client-types/static-1.21825",
      "outpost": "/outpost/static-1.4103",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4720",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5505",
      "magpie-types": "/magpie-types/static-1.4965",
      "simple-logging-lib": "/simple-logging-lib/static-1.2962",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6492",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45750",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15603",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18811",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18279",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10134",
      "directed-graph": "/directed-graph/static-1.848",
      "event-emitter": "/event-emitter/static-1.858",
      "fast-json-patch": "/fast-json-patch/static-1.61",
      "customer-data-associations": "/customer-data-associations/static-1.7237",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1675",
      "reporting-data": "/reporting-data/static-1.67094",
      "tanstack-virtual": "/tanstack-virtual/static-1.28",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4679",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3538",
      "self-service-api": "/self-service-api/static-1.10155",
      "crm_universal": "/crm_universal/static-1.21849",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9104",
      "content-embed-lib": "/content-embed-lib/static-1.7251",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12047",
      "remote-ui": "/remote-ui/static-1.63",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5507",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16737",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2919",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13234",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10284",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.373",
      "messaging-types-lib": "/messaging-types-lib/static-1.45711",
      "data-token-picker": "/data-token-picker/static-1.16246",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7743",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5234",
      "navigation-messaging": "/navigation-messaging/static-1.7024",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18237",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17355",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.504",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.836",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8520",
      "growth-data-modal": "/growth-data-modal/static-1.5291",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2981",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1644",
      "navigation-components": "/navigation-components/static-1.17697",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4652",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7439",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10948",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.633",
      "commerce-permissions": "/commerce-permissions/static-1.676",
      "products-iframe-lib": "/products-iframe-lib/static-1.7670",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10138",
      "data-agent-kit": "/data-agent-kit/static-1.54",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9839",
      "fsm": "/fsm/static-1.3645",
      "policy-lib": "/policy-lib/static-1.6694",
      "react-tinymce": "/react-tinymce/static-1.54979",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54105",
      "tinymce-plugins": "/tinymce-plugins/static-1.57219",
      "tinymce-themes": "/tinymce-themes/static-1.56075",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11963",
      "content-media-compositions": "/content-media-compositions/static-2.15970",
      "idb-keyval": "/idb-keyval/static-1.42",
      "media-bridge-lib": "/media-bridge-lib/static-1.18767",
      "ui-addon-opt": "/ui-addon-opt/static-4.8292",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5931",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4995",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7922",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19185",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8460",
      "wootric-nps": "/wootric-nps/static-1.6894",
      "nav-client-types": "/nav-client-types/static-1.2268",
      "purchase-motions-api": "/purchase-motions-api/static-1.5712",
      "reactive-lib": "/reactive-lib/static-1.634",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36887",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39255",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11640",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54402",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21206",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17480",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71636",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8362",
      "utility-belt": "/utility-belt/static-1.2450",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22361",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7345",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5554",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14555",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5022",
      "qrcode-generator": "/qrcode-generator/static-1.67",
      "trials-service-types": "/trials-service-types/static-1.3812",
      "deal-intel-utils": "/deal-intel-utils/static-1.1679",
      "storybook-react": "/storybook-react/static-1.31",
      "reporting-client-types": "/reporting-client-types/static-1.2430",
      "react-flip-move": "/react-flip-move/static-1.68",
      "FireAlarmUi": "/FireAlarmUi/static-1.4440",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4096",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10899",
      "association-settings-lib": "/association-settings-lib/static-1.10026",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57509",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12253",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12302",
      "final-form": "/final-form/static-1.68",
      "html-to-image": "/html-to-image/static-1.52",
      "nudge-client-utils": "/nudge-client-utils/static-1.2383",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6994",
      "property-management-iframe": "/property-management-iframe/static-1.12843",
      "property-usages-lib": "/property-usages-lib/static-1.5322",
      "reactflow": "/reactflow/static-1.62",
      "simple-data-table": "/simple-data-table/static-1.2518",
      "used-in-list-lib": "/used-in-list-lib/static-1.6849",
      "visual-association": "/visual-association/static-1.5777",
      "highcharts": "/highcharts/static-8.102",
      "reporting-visualizations": "/reporting-visualizations/static-1.59170",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3849",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.51",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2555",
      "ContentData": "/ContentData/static-1.68152",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.887",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1847",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.285",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.455",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.315",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6761",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3892",
      "ui-tool-access": "/ui-tool-access/static-1.10057",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1810",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1672",
      "user-context-client": "/user-context-client/static-1.4522",
      "nest": "/nest/static-1.134",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35410",
      "sales-views-client-types": "/sales-views-client-types/static-1.4173",
      "trellis-story-utils": "/trellis-story-utils/static-1.4428",
      "hub-http-contrib": "/hub-http-contrib/static-1.2953",
      "interframe": "/interframe/static-3.4673",
      "tinymce-data": "/tinymce-data/static-1.40190",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5122",
      "codemirror": "/codemirror/static-5.93",
      "layout-dnd-components": "/layout-dnd-components/static-1.12270",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11245",
      "react-codemirror": "/react-codemirror/static-1.10534",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14839",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8995",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9757",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7740",
      "copilot-plugins": "/copilot-plugins/static-1.10848",
      "products-ui-components": "/products-ui-components/static-1.39715",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80357",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6917",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54418",
      "commerce-products-api": "/commerce-products-api/static-1.2158",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56476",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102314",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7594",
      "reporting-ui-components": "/reporting-ui-components/static-2.64365",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14768",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17871",
      "stripe-connect-js": "/stripe-connect-js/static-1.66",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9456",
      "nested-table": "/nested-table/static-1.135",
      "association-translator": "/association-translator/static-1.3093",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8249",
      "settings-ui-nav": "/settings-ui-nav/static-2.10101",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20858",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2306",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5787",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4165",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2140",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2459",
      "whisper-core-api": "/whisper-core-api/static-1.6334",
      "property-management-common": "/property-management-common/static-1.5131",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14992",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11949",
      "ExportDialog": "/ExportDialog/static-6.10300",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33789",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9570",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14006",
      "highlight.js": "/highlight.js/static-1.77",
      "reporting-action-components": "/reporting-action-components/static-1.41016",
      "reporting-snowflake": "/reporting-snowflake/static-1.55712",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.430",
      "property-description-translator": "/property-description-translator/static-1.3762",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3557",
      "totals-ui-components": "/totals-ui-components/static-1.23330",
      "reporting-plugins": "/reporting-plugins/static-1.10152",
      "reporting-reports": "/reporting-reports/static-1.66772",
      "edison-service-client-types": "/edison-service-client-types/static-1.297",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10419",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16745",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19338",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7905",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.83",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14991",
      "simple-menus-lib": "/simple-menus-lib/static-1.16508",
      "academy-common-lib": "/academy-common-lib/static-1.13466",
      "dashboard-lib": "/dashboard-lib/static-1.81151",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8606",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3746",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8688",
      "apps-service-types": "/apps-service-types/static-1.3788",
      "oauth-service-types": "/oauth-service-types/static-1.4160",
      "academy-service-client": "/academy-service-client/static-1.3591",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28806",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};